import { c as component } from './bundle_chunk_svelte-tag_98d4fa80.js';

/**
 * This file is to add any JS or components that are specific to this template file
 * by default it is empty.
 */
import('./bundle_chunk_YoutubePlayer_aeda5ac0.js').then(_ref => {
  var {
    default: YoutubePlayer
  } = _ref;
  new component({
    component: YoutubePlayer,
    tagname: 'sv-youtube-player'
  });
});
